import Persistence from '../util/persistence';
import * as types from '../constants/cidraActions';
import { logSsf } from '../util/log';
import base64url from 'base64url';

const DEVICE_TOKEN_STORAGE_PREFIX = 'dt:';
const deviceTokenKeyRegex = /^dt:.*/;

/**
 * Attempt to delete any tokens that meet the format of SSF tokens.
 * This is not a high priority task, so we try to run it when render is complete.
 * Note: If this is ever a performance concern, we can switch to store tokens in IndexedDB
 * instead of localStorage and perform this task in a separate thread with Web Workers.
 */
export function queueTokenDeletion() {
  setTimeout(deleteExpiredTokens, 0);

  // tests ! we should maybe make this a separate function
  function deleteExpiredTokens() {
  // logSsf('Deleting expired tokens.');
    try {
      let keys = Persistence.getKeys();
      let deletedRecords = 0;
      const totalRecords = keys.length;

      const nowDate = new Date();

      for (let key of keys) {
        if (key.match(deviceTokenKeyRegex) ) {
          const jwt = Persistence.get(key);
          const jwtChunks = jwt.split('.');
          const jwtHeaders = jwtChunks[0];
          const decodedJwtHeaders = base64url.decode(jwtHeaders);
          const headerObj = JSON.parse(decodedJwtHeaders);
          const expirationTime = headerObj.exp;

          const expDate = new Date(expirationTime);

          if (nowDate > expDate) {
          // logSsf('Deleting expired key: ' + key);
            deletedRecords += 1;
            Persistence.remove(key);
          }
          else {
          // logSsf('Leaving unexpired key: ' + key);
          }
        }
      }
      const endTime = new Date();

      const timeDiff = endTime - nowDate;
      logSsf('Deleted expired tokens (' + deletedRecords + '/' + totalRecords + ') in ' + timeDiff + ' ms');
    }
    catch (ex) {
      console.error(ex);
      // Key has some of the format of a device token, but we aren't able to get the date -
      // leave it alone in case something else needs it.
      // logSsf('Leaving unparsable key: ' + key);
    }
  }
}


const UNITS = {
  'D': 'days',
  'H': 'hours',
  'M': 'minutes',
};

export function parsePeriodData(data) {
  try {
    const [unit, duration,] = data.split(':');

    if (duration < 2) {
      return duration + ' ' + UNITS[unit].slice(0, -1);
    }
    else {
      return duration + ' ' + UNITS[unit];
    }

  }
  catch (ex) {
    return '30 days';
  }
}

export function doSaveSkipSecondFactorToken(enterpriseId, subscriberId, ssfToken) {
  const key = DEVICE_TOKEN_STORAGE_PREFIX + enterpriseId + '.' + subscriberId;

  try {
    Persistence.set(key, ssfToken);
  }
  catch (ex) {
    console.error(ex);
  }
}

export function doGetSkipSecondFactorToken(enterpriseId, subscriberId) {
  const key = DEVICE_TOKEN_STORAGE_PREFIX + enterpriseId + '.' + subscriberId;

  try {
    return Persistence.get(key);
  }
  catch (ex) {
    console.error(ex);
  }
}

export function setSsfAvailable(value, periodData) {
  return {
    type: types.SET_SSF_AVAILABLE,
    value,
    periodData,
  };
}

export function setSkipSecondFactorToken(token) {
  return {
    type: types.SET_SSF_TOKEN,
    token,
  };
}

export function doToggleSkipSecondFactor(toggleState) {
  return {
    type: types.TOGGLE_SKIP_SECOND_FACTOR,
    toggleState,
  };
}
